import {formatDateString} from './formatDateString';
import {generateYearsBetween} from './generateYearsBetween';

export const generateAvailableYears = (dtAdesao: string) => {
	const startYear = Number(formatDateString(dtAdesao, 'P', 'yyyy'));

	return generateYearsBetween({startYear});
};
